module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter1"
    }
  }, [_vm._v("Chapter 1:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Organising the Home Front")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Wartime Life")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Evacuees and Bombing Raids")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Wartime Crime")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Industry and Agriculture")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("The Darlington Spitfire")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("RAF Middleton St George")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Darlington Sailors")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:"), _c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Darlington Soldiers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:"), _c('span', {
    staticClass: "sp_toc1"
  }, [_vm._v("Darlington & Teesdale Airmen and WAAFs")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0